export enum DOCUMENT_ACTIONS {
    STORE_DOCUMENT_ID = 'STORE_DOCUMENT_ID',
    STORE_DOCUMENT_NAME = 'STORE_DOCUMENT_NAME',
    STORE_DOCUMENT_URL = 'STORE_DOCUMENT_URL',
    STORE_DOCUMENT_LANGUAGE_CODE = 'STORE_DOCUMENT_LANGUAGE_CODE',
}
